import { render, staticRenderFns } from "./tagDialog.vue?vue&type=template&id=ec651bb0&scoped=true&"
import script from "./tagDialog.vue?vue&type=script&lang=js&"
export * from "./tagDialog.vue?vue&type=script&lang=js&"
import style0 from "./tagDialog.vue?vue&type=style&index=0&id=ec651bb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec651bb0",
  null
  
)

export default component.exports